var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGovbr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1",
    "data-name": "Grupo 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    height: 26.738,
    viewBox: "0 0 75 26.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2",
    "data-name": "Ret\\xE2ngulo 2",
    width: 75,
    height: 26.738,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M11.624,59.484v2.158a6.275,6.275,0,0,0-5.049-2.7C2.943,58.942,0,62.3,0,66.448s2.943,7.506,6.574,7.506a6.275,6.275,0,0,0,5.049-2.7v1.959a2.563,2.563,0,0,1-.6,1.653,5.1,5.1,0,0,1-4.041,1.8c-3.457,0-4.778-1.22-4.778-1.22v3.66s1.389.915,4.71.915S16.1,78.936,16.1,74.6V59.484ZM8.169,70.294a3.755,3.755,0,0,1,0-7.445,3.755,3.755,0,0,1,0,7.445",
    transform: "translate(0 -53.283)",
    fill: "#0e6eb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M176.73,61.059c-4.565,0-8.266,3.393-8.266,7.579s3.7,7.579,8.266,7.579S185,72.824,185,68.638s-3.7-7.579-8.266-7.579m0,11.454c-1.8,0-3.26-1.735-3.26-3.875s1.46-3.875,3.26-3.875,3.26,1.735,3.26,3.875-1.46,3.875-3.26,3.875",
    transform: "translate(-152.289 -55.196)",
    fill: "#ffa800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M511.756,5.659a6.262,6.262,0,0,0-5,2.639V0h-4.812V20.672h4.812V18.033a6.262,6.262,0,0,0,5,2.639c3.631,0,6.574-3.361,6.574-7.506s-2.943-7.506-6.574-7.506m-1.594,11.352a3.514,3.514,0,0,1-3.26-3.722,3.289,3.289,0,1,1,6.52,0,3.514,3.514,0,0,1-3.26,3.722",
    transform: "translate(-453.747)",
    fill: "#0e6eb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M334.3,68.118l-3.289,9.918-2.929-9.918H323l5.193,14.131h5.481l5.151-14.131Z",
    transform: "translate(-291.987 -61.578)",
    fill: "#54ab34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M454.222,174.249a2.15,2.15,0,1,1-2.15-2.15,2.15,2.15,0,0,1,2.15,2.15",
    transform: "translate(-406.722 -155.575)",
    fill: "#0e6eb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M679.272,64.987a3.465,3.465,0,0,0-1.95,1.97V64.589h-4.689v14.47h4.689V71a4.7,4.7,0,0,1,2.009-1.968,4.567,4.567,0,0,1,2.239-.582h1.479V64.589h-1.908a4.5,4.5,0,0,0-1.87.4",
    transform: "translate(-608.049 -58.387)",
    fill: "#ffa800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGovbr);
export default __webpack_public_path__ + "static/media/logo_govbr.43fd6f9db9d0527e211ab8beae3bb56e.svg";
export { ForwardRef as ReactComponent };